import React from "react"

function Illinois() {
    return (
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="44" height="80" viewBox="0 0 44 80">
            <path d="M37.040 0.72l-24.4-0.4 1.68 1.76 0.16 1.36 2.080 1.68-0.32 3.12-2.32 3.44-2.24 1.12-2.96 0.16-0.64 2.080 1.040 1.36 0.24 1.68-2 3.44-2.16 1.12 0.080 2.16-0.96 0.4-0.32 1.12 0.16 2.96 0.96 3.36 5.2 5.28 0.96 4.32 0.64 0.4 1.44-0.88 2.56 1.28-0.4 2.56-1.76 3.52 0.080 1.36 2.16 2.4 1.76 0.72 3.76 3.36v1.68l0.48 1.6-0.48 1.44 0.96 2.48 1.12 0.64-0.32-0.72 0.4-0.16 0.96 1.2h0.4l-0.48-1.040 1.68-1.84 4.4 1.84 0.72-0.24-0.32-3.52 3.6-1.2-0.64-1.68 1.040-1.52-0.48-0.72h0.48l-0.48-0.8h0.48v-1.84l0.88-0.32-0.64-0.16 0.88-0.88-0.72-0.72 0.56-0.88 0.72 0.32 0.96-2.080 1.040-0.48-0.16-0.72 1.44-2.4-0.24-2.16-1.36-1.92 0.8-1.040-0.32-1.36 0.88-0.32-0.080-27.76-2.64-5.92v-3.040z"></path>
        </svg>
    )
}

export default Illinois